import { render, staticRenderFns } from "./certs.vue?vue&type=template&id=73d64086&scoped=true&"
import script from "./certs.vue?vue&type=script&lang=js&"
export * from "./certs.vue?vue&type=script&lang=js&"
import style0 from "./certs.vue?vue&type=style&index=0&id=73d64086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d64086",
  null
  
)

export default component.exports